<template>
  <div class="row py-2" style="border-top: 1px solid gray">
    <div class="col-3">{{ userData.name }}
      <span v-show="userData.is_deleted" style="color:red; font-size: 0.5rem;">(已刪除)</span>
    </div>
    <div class="col-4">
      {{ userData.email }}
    </div>
    <div class="col-3">{{ userData.created_at }}</div>
    <div class="col-2">
      <button class="btn btn-danger btn-sm" data-toggle="modal" :data-target="`#deleteRegionModal` + userData.id">
        刪除
      </button>
    </div>
    <delete-user-from-region :region-id="regionId" :user-data="userData"
      @update-user="updateUser"></delete-user-from-region>
  </div>
</template>

<script>
import DeleteUserFromRegion from './DeleteUserFromRegion.vue';

export default {
  components: { DeleteUserFromRegion },
  data() {
    return {
      bodyHide: false,
    }
  },
  methods: {
    updateUser() {
      this.$emit('update-user');
    }
  },
  props: ['userData', 'regionId'],
}
</script>

<style>
.card-header p {
  line-height: 3rem;
  margin: auto;
  margin-right: 0;
  margin-left: 0;
}
</style>
